export default __webpack_public_path__ + "static/media/Kakaba Guide.d390c602.jpg";